import React, { useMemo } from "react";
import styles from "../styles/menus-evento.module.css";

import { useEventosConMenus } from "../hooks/useEventosConMenus";
import { useMenusPorEventoUI } from "../hooks/useMenusPorEventoUI";

import { filterAndSortEventos } from "../domain/menusFilters";
import { computeMenusKpis } from "../domain/menusKpis";

import MenusHeader from "../components/MenusHeader";
import MenusFiltersBar from "../components/MenusFiltersBar";
import MenusKpis from "../components/MenusKpis";
import EventosMenusList from "../components/EventoMenusList";

export default function MenusPorEventoPage() {
    const { loading, eventos, error } = useEventosConMenus();
    const ui = useMenusPorEventoUI();

    const filtered = useMemo(() => {
        return filterAndSortEventos({
            eventos,
            query: ui.query,
            dateFrom: ui.dateFrom,
            dateTo: ui.dateTo,
            estado: ui.estado,
            sortBy: ui.sortBy,
        });
    }, [eventos, ui.query, ui.dateFrom, ui.dateTo, ui.estado, ui.sortBy]);

    const kpi = useMemo(() => computeMenusKpis(filtered), [filtered]);

    if (loading) {
        return (
            <div className="menus-view">
                <div className="loading">Cargando menús…</div>
            </div>
        );
    }

    if (error) {
        return (
            <div className="menus-view">
                <div className="error">
                    <strong>Ha ocurrido un error:</strong> {error}
                </div>
            </div>
        );
    }

    return (
        <div className={styles["menus-view"]}>
            <MenusHeader />

            <MenusFiltersBar
                query={ui.query}
                onQuery={ui.setQuery}
                dateFrom={ui.dateFrom}
                onDateFrom={ui.setDateFrom}
                dateTo={ui.dateTo}
                onDateTo={ui.setDateTo}
                estado={ui.estado}
                onEstado={ui.setEstado}
                sortBy={ui.sortBy}
                onSortBy={ui.setSortBy}
            />

            <MenusKpis kpi={kpi} />

            <EventosMenusList
                eventos={filtered}
                isEventOpen={ui.isEventOpen}
                onToggleEvent={ui.toggleEvent}
                isMenuOpen={ui.isMenuOpen}
                onToggleMenu={ui.toggleMenu}
            />
        </div>
    );
}
